import Vue from 'vue'
import { Autocomplete, Slider, Switch } from '@oruga-ui/oruga'
import App from './App'

Vue.config.productionTip = false
Vue.use(Autocomplete)
Vue.use(Slider)
Vue.use(Switch)

const id = '#kpc-app'
const root = document.querySelector(id)

new Vue({
    render: (h) => h(App, {
        props: {
            searchHeaderElement: root.dataset['slot:searchHeader'],
            chartHeaderElement: root.dataset['slot:chartHeader'],
            chartFooterElement: root.dataset['slot:chartFooter'],
        },
    }),
}).$mount(id)
